import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CwpComponentDirective } from './directives';

@NgModule({
	imports: [CommonModule],
	declarations: [
		CwpComponentDirective
	],
	exports: [
		CwpComponentDirective
	]
})
export class CwpModule { }
